import { getGoogleFontsUrl } from '../config/fontConfig';

/**
 * Load Google Fonts dynamically
 * This function injects a link tag for Google Fonts into the document head
 * Only loads if Google Fonts are configured
 */
export const loadGoogleFonts = () => {
  const googleFontsUrl = getGoogleFontsUrl();
  
  if (!googleFontsUrl) {
    return; // No Google Fonts configured
  }

  // Check if font link already exists
  const existingLink = document.querySelector(`link[href="${googleFontsUrl}"]`);
  if (existingLink) {
    return; // Already loaded
  }

  // Create and inject the link tag
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = 'https://fonts.googleapis.com';
  document.head.appendChild(link);

  const link2 = document.createElement('link');
  link2.rel = 'preconnect';
  link2.href = 'https://fonts.gstatic.com';
  link2.crossOrigin = 'anonymous';
  document.head.appendChild(link2);

  const fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = googleFontsUrl;
  document.head.appendChild(fontLink);
};

/**
 * Apply font classes to document root
 * This function adds CSS classes to apply the configured fonts
 */
export const applyFontStyles = () => {
  const style = document.createElement('style');
  style.innerHTML = `
    html, body {
      font-family: var(--font-body);
    }
    
    h1, h2, h3, h4, h5, h6,
    a, button, [role="button"],
    .heading, .banner, .highlight {
      font-family: var(--font-heading);
    }
  `;
  document.head.appendChild(style);
};

const fontLoaderModule = {
  loadGoogleFonts,
  applyFontStyles,
};

export default fontLoaderModule;
